import {Box, IconButton, Paper, Popper, Stack, styled} from '@mui/material';

const TooltipPopper = styled(Popper)(() => ({
	zIndex: 1400,
}));

const TooltipContainer = styled(Box)(({theme}) => ({
	position: 'relative',
	marginBottom: theme.spacing(1),
}));

const TooltipPaper = styled(Paper)(({theme}) => ({
	padding: theme.spacing(2),
	maxWidth: 280,
	borderRadius: theme.spacing(2),
}));

const TooltipHeaderStack = styled(Stack)(({theme}) => ({
	marginBottom: theme.spacing(0.5),
}));

const TooltipCloseButton = styled(IconButton)(({theme}) => ({
	marginTop: theme.spacing(-0.5),
	marginRight: theme.spacing(-0.5),
}));

const TooltipArrow = styled(Box)(({theme}) => ({
	position: 'absolute',
	bottom: -8,
	left: '50%',
	transform: 'translateX(-50%)',
	width: 0,
	height: 0,
	borderLeft: '8px solid transparent',
	borderRight: '8px solid transparent',
	borderTop: `8px solid ${theme.palette.background.paper}`,
	filter: 'drop-shadow(0px 2px 1px rgba(0,0,0,0.15))',
}));

export {
	TooltipPopper,
	TooltipContainer,
	TooltipPaper,
	TooltipHeaderStack,
	TooltipCloseButton,
	TooltipArrow,
};
